import classNames from 'classnames';

import { Component, Element, h, Host, State, Watch } from '@stencil/core';
import { plus } from 'pn-design-assets/pn-assets/icons.js';

@Component({
  tag: 'pn-animated-tile',
  styleUrl: 'pn-animated-tile.scss',
})
export class PnAnimatedTile {
  @Element() hostElement: HTMLElement;

  @State() toggled: boolean = false;
  @State() transitionClassName: string = '';
  @State() animateIcon: string = '';

  onClickHandler = () => {
    this.toggled = !this.toggled;
  };

  @Watch('toggled')
  onToggledHandler() {
    this.transitionClassName = classNames({ 'fade': this.toggled, 'fade--reversed': !this.toggled });
    this.animateIcon = classNames({ 'animate': this.toggled, '': !this.toggled });
  }

  render() {
    return (
      <Host>
        <div class="pn-animated-tile__container">
          <div class={`pn-animated-tile__content cat-animate ${this.transitionClassName}`}>
            <slot name="side-a" />
            <slot name="side-b" />
          </div>
          <button type="button" aria-label="Read more" class={`pn-animated-tile__toggle cat-animate toggle ${this.animateIcon}`} onClick={this.onClickHandler}>
            <pn-icon icon={plus}></pn-icon>
          </button>
        </div>
      </Host>
    );
  }
}
